module.exports = __webpack_public_path__ + "static/media/capa_ledneon.0e5ce68b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/fotos/LedNeon/capa_ledneon.jpg
// module id = 328
// module chunks = 0